import { CoreRoute } from '@tech/intranet-core-protocol';

export const CoreRoutes: CoreRoute[] = [
  {
    name: 'Sample',
    icon: 'code',
    url: 'sample',
    children: [
      {
        name: 'Child 1',
        icon: 'add',
        url: '',
      },
    ],
  },
];
